import { useQuery } from 'codefabrik-gui-vue/src/apollo'
import { reportingService } from '@/services'
import { createMutationMixin } from '@/shared'

export function useCurrencies (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: reportingService.getCurrencies,
        mappingFunctions: {
          [name]: [(currency) => currency, () => []]
        }
      })
    ]
  }
}

export const useCreateSignificantEvent = () => createMutationMixin({
  name: 'createSignificantEvent',
  service: [reportingService.createSignificantEvent, 'reporting.createSignificantEventSuccess'],
  onSuccess () {
    this.$router.push({ name: 'significant-event-list' })
  },
})

export const useTriggerCPVCheck = () => createMutationMixin({
  name: 'triggerCPVCheck',
  service: [reportingService.triggerCPVCheck, 'reporting.triggerCPVCheckSuccessful'],
  onSuccess () {
    this.$router.push({ name: 'cpv-check-list' })
  },
})
